import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbsModule } from './breadcrumbs/breadcrumbs.module';
import { ListModule } from './list/list.module';
import { PageHeaderModule } from './page-header/page-header.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';

import { MatCardModule } from '@angular/material/card';
import { ScrollbarModule } from './scrollbar/scrollbar.module';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { ControlsComponent } from './controls/controls.component';
import { OrderControlsComponent } from './order-controls/order-controls.component';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DirectiveModule } from './directive/directive.module';
import { CalsoftpipeModule } from './utils/calsoftpipe/calsoftpipe.module';
import { ExcelProductsizeChartComponent } from './excel-productsize-chart/excel-productsize-chart.component';
import { PriceTablePlanComponent } from './price-table-plan/price-table-plan.component';
import { PriceTablePlan2Component } from './price-table-plan2/price-table-plan2.component';
import { LocationComponent } from './location/location.component';
import { MapLocationComponent } from './map-location/map-location.component';
import { PriceTablePlan3Component } from './price-table-plan3/price-table-plan3.component';
import { PriceTablePlan4Component } from './price-table-plan4/price-table-plan4.component';
import { CustomFlexLayoutModule } from './flex-layout/custom-flex-layout.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PriceTablePlan5Component } from './price-table-plan5/price-table-plan5.component';
import { PriceTablePlan6Component } from './price-table-plan6/price-table-plan6.component';
import { CrmBusinessEditComponent } from './crm-business-edit/crm-business-edit.component';
import { ChatmessageruiModule } from './chatmessagerui/chatmessagerui.module';
import { CommonDownloadModule } from '../pages/common-download/common-download.module';
import { CommonAttributeDialogComponent } from './common-attribute-set/add-editcommon-attribute-set/common-attribute-dialog/common-attribute-dialog.component';
import { KnowledgeBaseComponent } from './aiagents/tabs/knowledge-base/knowledge-base.component';
import { AddKnowledgeDialogComponent } from './aiagents/tabs/knowledge-base/dialogs/add-knowledge-dialog/add-knowledge-dialog.component';
import { CalsoftAuditModule } from '../pages/audit/audit.module';
import { ConfirmDialogComponent } from '../whatsapp/confirm-dialog/confirm-dialog.component';
import { DynamicInvoiceTableComponent } from './dynamic-invoice-table/dynamic-invoice-table.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BreadcrumbsModule,
        ListModule,
        PageHeaderModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatInputModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        CustomFlexLayoutModule,
        MatCardModule,
        MatPaginatorModule,
        MatListModule,
        MatTabsModule,
        MatSnackBarModule,
        MatSidenavModule,
        MatRippleModule,
        MatTooltipModule,
        MatRadioModule,
        ScrollbarModule,
        ScrollingModule,
        DirectiveModule,
        CalsoftpipeModule,
        NgxMatSelectSearchModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        CommonDownloadModule,
        MatNativeDateModule,
        CommonDownloadModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatDialogModule,
        CalsoftAuditModule,
        ChatmessageruiModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BreadcrumbsModule,
        ListModule,
        PageHeaderModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatInputModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        CustomFlexLayoutModule,
        MatCardModule,
        MatPaginatorModule,
        MatTabsModule,
        MatListModule,
        MatSnackBarModule,
        MatSidenavModule,
        MatRadioModule,
        MatRippleModule,
        MatTooltipModule,
        ScrollbarModule,
        ScrollingModule,
        DirectiveModule,
        NgxMatSelectSearchModule,
        MatAutocompleteModule,
        CommonDownloadModule,
        ControlsComponent, OrderControlsComponent, CalsoftpipeModule, ExcelProductsizeChartComponent, PriceTablePlanComponent, PriceTablePlan2Component, PriceTablePlan3Component, PriceTablePlan4Component, PriceTablePlan5Component, PriceTablePlan6Component, CrmBusinessEditComponent, CommonAttributeDialogComponent,
        KnowledgeBaseComponent, AddKnowledgeDialogComponent, ConfirmDialogComponent, DynamicInvoiceTableComponent,
        MatMenuModule, MatProgressSpinnerModule, MatSlideToggleModule, MatDialogModule,
        CalsoftAuditModule,
        ChatmessageruiModule
    ],
    declarations: [ControlsComponent, OrderControlsComponent, ExcelProductsizeChartComponent, PriceTablePlanComponent, PriceTablePlan2Component, LocationComponent, MapLocationComponent, PriceTablePlan3Component, PriceTablePlan4Component, PriceTablePlan5Component, PriceTablePlan6Component, CrmBusinessEditComponent, CommonAttributeDialogComponent, KnowledgeBaseComponent, AddKnowledgeDialogComponent, ConfirmDialogComponent, DynamicInvoiceTableComponent]
})
export class SharedModule {
}
